export const centerSessionCommissionTableKeys = {
    all: ['centerSessionCommissionTable'] as const,
    list: (centerId: string, year: string, month: string) =>
        [...centerSessionCommissionTableKeys.all, 'list', centerId, year, month] as const,
    coach: (centerId: string, coachId: string, year: string, month: string) =>
        [...centerSessionCommissionTableKeys.all, 'coach', centerId, coachId, year, month] as const,
};
